import WindowResolver from './WindowResolver'


declare global {
  interface Window {
    mixpanel: {
      get_distinct_id(): string
      people: {
        set(...args: any[]): void
      }
    }
  }
}

/*

  From docs:

  window.mixpanel.track(...)
  window.mixpanel.people.set(...)

  Usage:

  mixpanel.track(...)
  mixpanel.people.set(...)

 */

const windowEntity = 'mixpanel'

const methods = {
  alias: true,
  get_distinct_id: true,
  get_property: true,
  identify: true,
  register: true,
  register_once: true,
  reset: true,
  track: true,
  people: {
    set: true,
  },
}

interface IMixpanel {
  alias(alias: string, currentId?: string): void
  get_distinct_id(): string
  get_property(propertyName: string): any
  identify(uniqueId?: string): void
  register(properties: { [key: string]: any }, days?: number): void
  register_once(properties: { [key: string]: any }, defaultValue?: string, days?: number): void
  reset(): void
  track(eventName: string, properties?: { [key: string]: any }, callback?: () => void): void
  people: {
    set(prop: string, value: any, callback?: () => void): void
    set(keys: { [index: string]: any }, callback?: () => void): void
  }
}

const mixpanel = new WindowResolver({
  name: windowEntity,
  methods,
  resolver: () => Boolean(window.mixpanel && window.mixpanel.get_distinct_id),
  eventHandler: (methodName, ...args) => {
    if (methodName === 'people.set') {
      window.mixpanel.people.set(...args)
    }
    else {
      window.mixpanel[methodName](...args)
    }
  },
}) as unknown as IMixpanel


export default mixpanel

export {
  windowEntity,
  methods,
}
